module.exports = __webpack_public_path__ + "static/media/girl-2.8ada3456.svg";